<script>
import {
  BModal,
  BButtonGroup,
  VBTooltip,
  BTabs,
  BTab,
  BCard,
  BCardText,
} from 'bootstrap-vue';

export default {
  components: {
    BModal,
    BButtonGroup,
    BTabs,
    BTab,
    BCard,
    BCardText,
  },

  directives: {
    'b-tooltip': VBTooltip,
  },

  data() {
    return {
      isHoveredActivities: false,
      isHoveredInformations: false,
    }
  },

  store: ['users'],

  /**
     * Prepare the component.
     */
  created () {
    Bus.$emit('leadRetrieved', this.lead);
  },

  props: ['user', 'lead'],

  methods: {
    toggleDeleteLeadButton (isAdmin) {
      Bus.$emit('deleteLeadButtonToggled', this.lead, isAdmin);
    },

    toggleEditLeadButton () {
      Bus.$emit('editLeadButtonToggled', this.lead);
    },

    toggleCreateDealButton () {
      Bus.$emit('createDealButtonToggled', this.lead);
    },

    toggleAutomationModal () {
      this.$refs['automation-modal'].toggle();
    },

    getUsers () {
      const users = this.users.map((user) => ({ value: user.id, text: user.name }));

      return JSON.stringify(users);
    },
  },
};
</script>

<style lang="scss">

@import '../../../sass/variables';

  .nav-tabs .nav-link:first-child {
    border-top-left-radius: 15px;
}

.nav-tabs .nav-link:not(.active) {
  border: 0px;
  font-weight: 600;
  color: $salesflow-font-gray;

  &:hover {
    border: 0px;
  }
}

.nav-tabs .nav-link.active {
  color: $salesflow-primary;
  font-weight: 600;
  border-color: $salesflow-outline-gray-medium;
  border-bottom: 1px solid transparent;
}
</style>
